namespace appn.views.brandCenter.settings {
    let _currentIconSet = appn.emptyString;

    export function init(): void {
        (appn as any).filesUploading = 0;
        addEvents();

        // Hook in the default value for events
        _currentIconSet = String($('#AaaSDetails_IconSet').val());

        appn.icons.init();
    }

    function addEvents(): void {
        $('#AaaSDetails_IconSet').change(function() {
            const newIconSet = $(this).val() as string;
            let iconcount = 0;
            $('.fileinput-new.thumbnail img').each(function() {
                const currentImageSrc = $(this).attr('src');
                const imglazy = $(this).data('imglazyurl') as string;

                if (currentImageSrc && currentImageSrc.indexOf('Files/') === -1)
                    $(this).attr('src', currentImageSrc?.replace(_currentIconSet, newIconSet));

                if (imglazy && imglazy.indexOf('Files/') === -1)
                    $(this).attr('data-imglazyurl', imglazy.replace(_currentIconSet, newIconSet));
            });
            _currentIconSet = newIconSet;
        });

        ($('.iconUpload') as any).fileupload({
            dataType: 'json',
            change: function(event: Event, data: any) {
                const file = data.files[0];
                const isValidExt = utils.isValidFileExtension(['.png'], file.name);
                const isValidSize = appn.utils.IsValidFileSize(50, file);

                if (!isValidExt || !isValidSize) {
                    // Clear out the bad file
                    const that = this;
                    setTimeout(function() {
                        $(that).closest('.fileinput').find('.btn.fileinput-exists.btn-remove').click();
                    }, 500);
                }

                return isValidExt && isValidSize;
            },
            submit: function(event: Event, data: any) {
                data.formData = {
                    iconname: $(this).closest('.iconInfo').data('icon'),
                    brandid: $('#Brand_Id').val(),
                    icontype: $(this).closest('.iconInfo').data('icontype')
                };
            },
            send: function(event: Event, data: any) {
                (appn as any).filesUploading++;
            },
            always: function(event: Event, data: any) {
                (appn as any).filesUploading--;
            },
            done: function(event: Event, data: any) {
                if (data.result.error) {
                    appn.fileUploadUtils.fileUploadFailed(data.result.error);
                    return;
                }

                $(this).closest('.iconInfo').find('input.iconPath').val(data.result);
            },
            error: function(response: any) {
                (appn as any).fileUploadUtils.fileUploadFailed();
            },
            fail: function(event: Event, data: any) {
                (appn as any).fileUploadUtils.fileUploadFailed();
            }
        });

        $('.iconReset').on('click', function(event) {
            event.preventDefault();

            const iconPath = $(this).closest('.iconInfo').find('input.iconPath');
            const setName = _currentIconSet;
            let setPath = String(iconPath.val()).replace(`Files/Brand/${$('#Brand_Id').val()}`, setName);

            if (setPath.contains('sys_'))
                setPath = setPath.replace('sys_', appn.emptyString);
            iconPath.val(setPath);

            $(this).closest('.fileinput').find('.thumbnail')
                .find('img').attr('src', `${urls.root}Content/icons/${setPath}`);
            $(this).hide();
        });
    }
}
